import { render, staticRenderFns } from "./urbanismdocument-add.vue?vue&type=template&id=481a35d8&"
import script from "./urbanismdocument-add.vue?vue&type=script&lang=js&"
export * from "./urbanismdocument-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports